import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Language, LanguagesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class LanguagesDataService {

  private uri: string = `${environment.apiUrl}languages`;
  private cacheKey: string = 'languages.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getLanguage(id: number): Observable<Language|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getLanguages(parameters: {[param: string]: string | string[]}): Observable<LanguagesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addLanguage(data: Language): Observable<Language|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addLanguages(data: Language[]): Observable<Language[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateLanguage(data: Language): Observable<Language|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateLanguages(data: Language[]): Observable<Language[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchLanguage(data: Language): Observable<Language|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchLanguages(data: Language[]): Observable<Language[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteLanguage(data: Language): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteLanguages(data: Language[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((language) => {
      ids.push(language.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
